import * as Styled from './activity-center-skeleton.styled';

const SAVED_JOB_PLACEHOLDER_COUNT = 5;

export const ActivityCenterSkeleton: React.FC = () => (
  <Styled.Container data-qa="activity-center-skeleton">
    <Styled.Hero amountRows={1} size="medium" />
    <Styled.BodyCopy amountRows={2} />
    <Styled.SavedJobs>
      <Styled.SectionHeadline amountRows={1} size="large" />
      {Array.from({ length: SAVED_JOB_PLACEHOLDER_COUNT }, (_, index) => (
        <Styled.SavedJob
          data-qa="activity-center-skeleton-saved-job"
          key={index}
        >
          <Styled.JobImage size="medium" />
          <Styled.JobText>
            <Styled.JobHeadline alignment="left" amountRows={1} size="small" />
            <Styled.JobBodyCopy alignment="left" amountRows={2} />
          </Styled.JobText>
        </Styled.SavedJob>
      ))}
    </Styled.SavedJobs>
  </Styled.Container>
);
